import type { ReactElement, ReactNode } from "react";
import { motion } from "framer-motion";
import { TOOLTIP_CONTENT_FADE_TRANSITION, TOOLTIP_TEXT_STYLE, } from "./ctooltip-constants";
import { CtooltipBody } from "./CtooltipBody";
import { CtooltipTitle } from "./CtooltipTitle";
import { dataEl, type DataElScope } from "@/utils/dataEl";
interface CtooltipTextProps {
    dataElScope: DataElScope;
    body?: ReactNode;
    title?: string;
}
export function CtooltipText({ dataElScope, body, title }: CtooltipTextProps): ReactElement {
    return (
      <motion.div data-el={dataEl(dataElScope, "Text/Root")} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={TOOLTIP_CONTENT_FADE_TRANSITION} style={TOOLTIP_TEXT_STYLE}>
        {title && <CtooltipTitle title={title}/>}
        {body && <CtooltipBody body={body}/>}
      </motion.div>
    );
}
